import { Injectable } from "@angular/core"
import { Observable } from "rxjs";
import { IMarkNotificationAsReadModel } from "src/app/ViewModel/PushNotificationModel";
import { CommonService } from "../Common.service";
import { RestApiService } from "../rest-api.service"


@Injectable({ providedIn: "root" })

export class PushNotificationService {
    private endPoints = {
        getPushNotificationList: 'PushNotification/GetNotifications',
        markAsRead: 'PushNotification/MarkAsRead'
    }

    constructor(private restAPIService: RestApiService, private _commonService: CommonService) {

    }

    public getPushNotificationList(): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getPushNotificationList, { UserId: this._commonService.getLoggedInUserId() });
    }

    public markAsReadNotification(reqModel: IMarkNotificationAsReadModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.markAsRead, reqModel);
    }


}